import React, { useState } from 'react';
import Lottie from 'lottie-react';

import { PROFILE_STATUS } from 'components/evieApp/utils';
import { useTabSettings } from 'utils/hooks/useTabSettings';
import heartLoader from 'assets/heart-loader.json';

import Layout from 'components/evieOnboarding/Layout';
import BottomNav from 'components/evieApp/BottomNav';
import ProfileContent from 'components/evieApp/ProfileContent';
import PersonalData from 'components/evieApp/PersonalData';
// import ChangePassword from 'components/evieApp/ChangePassword';
import { useEvieAppContext } from 'components/evieApp/EvieAppProvider';

import './evie-profile.scss';

const EvieProfile = () => {
  useTabSettings('Evie', '/evie-favicon.ico');
  const { loading } = useEvieAppContext();
  const [profileStatus, setProfileStatus] = useState(PROFILE_STATUS.IDLE);

  const handleChangeStatus = (status) => {
    setProfileStatus(status);
  };

  return (
    <>
      <Layout>
        {!loading && <BottomNav />}
        {!loading && profileStatus === PROFILE_STATUS.IDLE && (
          <ProfileContent onGoPersonalData={() => handleChangeStatus(PROFILE_STATUS.PERSONAL)} />
        )}
        {!loading && profileStatus === PROFILE_STATUS.PERSONAL && (
          <PersonalData onGoProfile={() => handleChangeStatus(PROFILE_STATUS.IDLE)} />
        )}
        {/* {!loading && profileStatus === PROFILE_STATUS.CHANGE_PASSWORD && (
          <ChangePassword onGoPersonalData={() => handleChangeStatus(PROFILE_STATUS.PERSONAL)} />
        )} */}
      </Layout>
      {loading && (
        <div className="onboarding-layout__lottie">
          <Lottie animationData={heartLoader} loop style={{ width: 140, height: 110 }} />
        </div>
      )}
    </>
  );
};

export default EvieProfile;
